import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'

export default function (app) {
  app.use(DatePicker)
}
  
